import "@/features/landing/landing.css";
import { LandingHeader } from "@/features/landing/components/LandingHeader";
import { HeroSection } from "@/features/landing/components/HeroSection";
import { GettingStartedSection } from "@/features/landing/components/GettingStartedSection";
import { AudienceSection } from "@/features/landing/components/AudienceSection";
import { HowItWorksSection } from "@/features/landing/components/HowItWorksSection";
import { FeaturesSection } from "@/features/landing/components/FeaturesSection";
import { VerificationSection } from "@/features/landing/components/VerificationSection";
import { SecuritySection } from "@/features/landing/components/SecuritySection";
import { OrganizationsSection } from "@/features/landing/components/OrganizationsSection";
import { TestimonialsSection } from "@/features/landing/components/TestimonialsSection";
import { CtaSection } from "@/features/landing/components/CtaSection";
import { LandingFooter } from "@/features/landing/components/LandingFooter";
import { ContactProvider } from "@/features/landing/components/ContactModal";

/** Public marketing page, served at /about. */
export function LandingPage() {
  return (
    <ContactProvider>
      {/* index.css gives every heading the Sora font app-wide; this design is all Inter. */}
      <div className="landing-page min-h-screen scroll-smooth bg-white font-sans text-[#120240] [&_:is(h1,h2,h3)]:font-sans">
        <LandingHeader />
        <main>
          <HeroSection />
          <GettingStartedSection />
          <AudienceSection />
          <HowItWorksSection />
          <FeaturesSection />
          <VerificationSection />
          <SecuritySection />
          <OrganizationsSection />
          <TestimonialsSection />
          <CtaSection />
        </main>
        <LandingFooter />
      </div>
    </ContactProvider>
  );
}
